import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {requiresAuth: true}
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('../views/About.vue')
    },
    {
        path: '/signup',
        name: 'signup',
        component: () => import('../views/SignUp/Request.vue')
    },
    {
        path: '/login/:token?',
        name: 'login',
        props: true,
        component: () => import('../views/Login.vue')
    },
    {
        path: '/admin/login/:token?',
        redirect: {name: 'login'}
    },
    {
        path: '/admin',
        name: 'admin',
        component: () => import('../views/admin/Admin'),
        children: [
            {
                path: 'app/settings',
                name: 'admin.app.settings',
                component: () => import('../views/admin/App/Settings')
            },
            {
                path: 'subscription',
                name: 'admin.subscription',
                component: () => import('../views/admin/Subscription/List')
            },
            {
                path: 'driver/:page?',
                name: 'admin.driver',
                props: true,
                component: () => import('../views/admin/Driver/List')
            },
            {
                path: 'driver/:id/view',
                name: 'admin.driver.view',
                props: true,
                component: () => import('../views/admin/Driver/One')
            },
            {
                path: 'wallet/client/:page?',
                name: 'admin.wallet.client',
                props: true,
                component: () => import('../views/admin/Wallet/Client/List')
            },
            {
                path: 'wallet/client/:id/view',
                name: 'admin.wallet.client.view',
                props: true,
                component: () => import('../views/admin/Wallet/Client/One')
            },
            {
                path: 'wallet/client/:id/create-transfer',
                name: 'admin.wallet.client.createTransfer',
                props: true,
                component: () => import('../views/admin/Wallet/Client/Money/CreateTransfer')
            },
            {
                path: 'wallet/client/:id/create-withdraw',
                name: 'admin.wallet.client.createWithdraw',
                props: true,
                component: () => import('../views/admin/Wallet/Client/Money/CreateWithdraw')
            },
            {
                path: '/admin/project-wallet/',
                component: () => import('../views/admin/Wallet/ProjectWallet/ProjectWallet'),
                children: [
                    {
                        path: 'view',
                        name: 'admin.project_wallet.view',
                        props: true,
                        component: () => import('../views/admin/Wallet/ProjectWallet/One')
                    },
                    {
                        path: 'attach-payment',
                        name: 'admin.project_wallet.attach_payment',
                        props: true,
                        component: () => import('../views/admin/Wallet/ProjectWallet/Attach/Payment')
                    },
                    {
                        path: 'attach-transfer',
                        name: 'admin.project_wallet.attach_transfer',
                        props: true,
                        component: () => import('../views/admin/Wallet/ProjectWallet/Attach/Transfer')
                    },
                    {
                        path: 'create/payment',
                        name: 'admin.project_wallet.create.payment',
                        props: true,
                        component: () => import('../views/admin/Wallet/ProjectWallet/Initiate/Payment')
                    },
                    {
                        path: 'create/transfer',
                        name: 'admin.project_wallet.create.transfer',
                        props: true,
                        component: () => import('../views/admin/Wallet/ProjectWallet/Initiate/Transfer')
                    },
                    {
                        path: 'client/:page?',
                        name: 'admin.project_wallet.client',
                        props: true,
                        component: () => import('../views/admin/Wallet/ProjectWallet/Client/List')
                    },
                    {
                        path: 'client/:id/view',
                        name: 'admin.project_wallet.client.view',
                        props: true,
                        component: () => import('../views/admin/Wallet/ProjectWallet/Client/One')
                    },
                    {
                        path: 'client/:id/create-transfer',
                        name: 'admin.project_wallet.client.createTransfer',
                        props: true,
                        component: () => import('../views/admin/Wallet/ProjectWallet/Client/Money/CreateTransfer')
                    },
                    {
                        path: 'client/:id/create-withdraw',
                        name: 'admin.project_wallet.client.createWithdraw',
                        props: true,
                        component: () => import('../views/admin/Wallet/ProjectWallet/Client/Money/CreateWithdraw')
                    },
                ]
            },
            {
                path: 'wallet/wallet-project/:page?',
                name: 'admin.wallet.wallet_project',
                props: true,
                component: () => import('../views/admin/Wallet/Project/List')
            },
            {
                path: 'wallet/wallet-project/:id/view',
                name: 'admin.wallet.wallet_project.view',
                props: true,
                component: () => import('../views/admin/Wallet/Project/One')
            },
            {
                path: 'projects',
                name: 'admin.projects',
                props: true,
                component: () => import('../views/admin/Project/List')
            },
            {
                path: 'projects/create',
                name: 'admin.projects.create',
                props: true,
                component: () => import('../views/admin/Project/Create')
            }
        ]
    },
    {
        path: '/404',
        name: '404',
        component: () => import('../views/NotFound'),
    }, {
        path: '*',
        redirect: '/404'
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
